import { NgModule } from "@angular/core";
import { DropzoneComponent } from "src/app/components/ui/dropzone/dropzone.component";
import { CommonModule } from "@angular/common";
import { TranslocoModule } from "@jsverse/transloco";
import { ButtonModule } from "src/app/components/ui/button/button.module";
import { PipesModule } from "src/app/pipes/pipes.module";
import { DxButtonModule, DxProgressBarModule } from "devextreme-angular";

@NgModule({
  imports: [
    CommonModule,
    TranslocoModule,
    ButtonModule,
    PipesModule,
    DxProgressBarModule,
    DxButtonModule
  ],
  exports: [DropzoneComponent],
  declarations: [DropzoneComponent]
})
export class DropzoneModule {}
